import { dateTimeToView } from "helpers/date";
import { ymEvent } from "helpers/system";
import Pencil from "icons/planning/pencil.svg";
import ShiftChange from "icons/planning/shift-change.svg";
import Wrench from "icons/planning/wrench.svg";
import { UmamiManager } from "lib/umami";
import policy from "policies";
import React, { useEffect, useState } from "react";
import ColumnDispatcherForm from "./columnDispatcherForm";
import MechanicForm from "./mechanicForm";
import NoteForm from "./noteForm";

export default function ExpandedCar(props) {
    const { car, trailer, driver, serviceWorks, driverShift } = props.data;
    const accessPermitIds = (car.accessPermitIds ?? [])
        .concat(trailer?.accessPermitIds ?? [])
        .concat(driver?.accessPermitIds ?? []);
    const [planningComment, setPlanningComment] = useState(car.planningComment?.comment ?? "");
    const [note, setNote] = useState(car.note);
    const [mechanic, setMechanic] = useState(car.mechanic);
    const [columnDispatcher, setColumnDispatcher] = useState(car.columnDispatcher);
    const canEditPlanning = !policy("user", { user: { roles: props.roles } }).isOnlyExtendedViewer();

    useEffect(() => {
        UmamiManager.track("VehicleNameClicked");
        ymEvent("TripPlanningCarDetailsUsed");
    }, []);

    const changeMechanic = () => {
        UmamiManager.track("VehicleCardBlock3PeniconCliced");
        ymEvent("TripPlanningCarDetailsUsed");

        props.modal({
            name: "default",
            title: "Механик",
            windowMod: "sm",
            CustomBody: MechanicForm,
            bodyData: { setMechanic, mechanic, carId: car.id },
        });
    };
    const changeColumnDispatcher = () => {
        UmamiManager.track("VehicleCardBlock3PeniconCliced");
        ymEvent("TripPlanningCarDetailsUsed");

        props.modal({
            name: "default",
            title: "Колонный",
            windowMod: "sm",
            CustomBody: ColumnDispatcherForm,
            bodyData: { setColumnDispatcher, columnDispatcher, carId: car.id },
        });
    };

    const changeNote = () => {
        UmamiManager.track("VehicleCardBlock2PeniconCliced");
        ymEvent("TripPlanningCarDetailsUsed");

        props.modal({
            name: "default",
            title: "Комментарий к сцепке",
            windowMod: "sm",
            CustomBody: NoteForm,
            bodyData: { setNote, note, carId: car.id },
        });
    };

    const changePlanningComment = () => {
        ymEvent("TripPlanningCarDetailsUsed");
        props.modal({
            name: "planningCommentForm",
            title: "Редактирование комментария",
            carId: car.id,
            planningComment,
            callback: (data) => {
                if (!data) {
                    return;
                }
                setPlanningComment(data.planningComment);
            },
        });
    };

    return (
        <div className="p-expanded">
            <div className="p-expanded__card">
                <div className="p-expanded__card-header">Данные по сцепке</div>
                <div className="row pb-2">
                    <div className="col-6">
                        <span className="text-muted">Тип кузова</span>{" "}
                        <span className="font-weight-semibold pl-2">{trailer?.type?.displayName}</span>
                    </div>
                    <div className="col-6">
                        <span className="text-muted">Тип загрузки</span>
                        <span className="font-weight-semibold pl-2">
                            {trailer?.loadUnloadOptions?.map((item) => item.displayName).join(", ")}
                        </span>
                    </div>
                </div>
                {accessPermitIds.length > 0 && (
                    <>
                        <div className="p-expanded__card-subtitle">Допуски и доп. оборудование</div>
                        <div className="d-inline-flex gap-1 pb-2">
                            {props.accessPermits.map((item) =>
                                accessPermitIds.includes(item.id) ? (
                                    <div
                                        key={item.id}
                                        className={accessPermitIds.includes(item.id) ? "text-success" : "text-danger"}
                                    >
                                        {item.image?.accessUrlLink && (
                                            <img
                                                className="mr-1"
                                                src={item.image?.accessUrlLink}
                                                width={20}
                                                alt={item.name || ""}
                                            />
                                        )}
                                        <small>{item.name}</small>
                                    </div>
                                ) : null,
                            )}
                        </div>
                    </>
                )}
                <div className="p-expanded__card-subtitle d-flex justify-content-between">
                    Комментарий
                    {canEditPlanning && <Pencil className="cursor-pointer pl-1" onClick={changePlanningComment} />}
                </div>
                <div className="white-space-pre-line">{planningComment ?? <>&mdash;</>}</div>
            </div>
            <div className="p-expanded__card">
                <div className="p-expanded__card-header d-flex justify-content-between">
                    Дополнительные данные по сцепке
                    {canEditPlanning && <Pencil className="cursor-pointer pl-1" onClick={changeNote} />}
                </div>
                <div className="white-space-pre-line">{note ?? <>&mdash;</>}</div>
            </div>
            <div className="p-expanded__card">
                <div className="p-expanded__card-header">Контакты</div>
                <div className="d-flex justify-content-between align-items-center gap-2">
                    <div>
                        <span className="text-muted">Механик:</span>&nbsp;
                        <span className="pl-2">
                            {mechanic?.name}
                            {mechanic?.phoneNumber && (
                                <a
                                    className="pl-1"
                                    href={`callto:${mechanic?.phoneNumber}`}
                                    onClick={() => ymEvent("TripPlanningContactPhoneClicked")}
                                >
                                    {mechanic?.phoneNumber}
                                </a>
                            )}
                        </span>
                    </div>
                    {canEditPlanning && <Pencil className="cursor-pointer pl-1" onClick={changeMechanic} />}
                </div>
                <div className="d-flex justify-content-between align-items-center pb-3 gap-2">
                    <div>
                        <span className="text-muted">Колонный:</span>&nbsp;
                        <span className="pl-2">
                            {columnDispatcher?.name}
                            {columnDispatcher?.phoneNumber && (
                                <a
                                    className="pl-1"
                                    href={`callto:${columnDispatcher?.phoneNumber}`}
                                    onClick={() => ymEvent("TripPlanningContactPhoneClicked")}
                                >
                                    {columnDispatcher?.phoneNumber}
                                </a>
                            )}
                        </span>
                    </div>
                    {canEditPlanning && <Pencil className="cursor-pointer pl-1" onClick={changeColumnDispatcher} />}
                </div>
                {driverShift && (
                    <>
                        <div className="p-expanded__card-subtitle">
                            <ShiftChange /> Пересменка:
                        </div>
                        <div>
                            Локация: {driverShift.address},{" "}
                            {dateTimeToView(driverShift.plannedEndDateOfCurrentShift, "DD.MM.YYYY HH:mm (Z)")} -{" "}
                            {dateTimeToView(driverShift.plannedStartDateOfNextShift, "DD.MM.YYYY HH:mm (Z)")}
                        </div>
                    </>
                )}
                {serviceWorks?.length > 0 && (
                    <>
                        <div className="p-expanded__card-subtitle">
                            <Wrench /> ТО:
                        </div>
                        {serviceWorks.map(({ startDate, endDate, addresses }, i) => (
                            <div key={i}>
                                {dateTimeToView(startDate, "DD.MM.YYYY HH:mm (Z)")} -{" "}
                                {dateTimeToView(endDate, "DD.MM.YYYY HH:mm (Z)")}
                                <div>
                                    <div className="font-weight-semibold text-muted">Плановые СТО:</div>
                                    <ul className="mb-0">
                                        {addresses.map((address, index) => (
                                            <li key={index}>{address}</li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        ))}
                    </>
                )}
            </div>
        </div>
    );
}
